

// import React, { useEffect, useState } from 'react'
// import CustomTable from '../../../Components/Table/CustomTable'
// // import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
// import { Grid } from '@mui/material';
// import actions from "../../../ReduxStore/actions/index";
// import { useDispatch, useSelector } from "react-redux";
// import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
// import BannerinputGetModal from '../../ContentManagement/CommonModal/BannerModal/BannerinputGetModal';
// import SchemeCreateModal from '../Modal/SchemeCreateModal';
// import UserReferralSchemeModal from '../Modal/UserReferralSchemeModal';
// import { format } from 'date-fns';
// // import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModal';

// const UserReferalsSheme = () => {
//   const dispatch = useDispatch()
//   const tableData = [
//     { title: 'Diamond Referral', startDate: "15/Mar/2025", EndDate: "15/Mar/2026", Reap: "3.8g", userType: "individual", Status: "Pending" },
//     { title: 'Ruby Referral', startDate: "15/Mar/2025", EndDate: "15/Mar/2026", Reap: "3.8g", userType: "individual", Status: "Pending" },

//   ];



//   const { getAllTiers } = useSelector(
//     (state) => state?.getAllTiers
//   );


//   const { createTier } = useSelector(
//     (state) => state?.createTier
//   );


//   const { inactivateLastTier } = useSelector(
//     (state) => state?.inactivateLastTier
//   );

//   const { activateLastTier } = useSelector(
//     (state) => state?.activateLastTier
//   );


//   useEffect(() => {
//     const fetchData = async () => {
//       const data1 = {
//         data: {},
//         method: "get",
//         apiName: `getAllTiers`,
//       };
//       await dispatch(actions.GETALLTIERS(data1));
//     };
//     fetchData();
//   }, [dispatch, createTier,inactivateLastTier,activateLastTier]);

//   // const tableHeadData = ['S.No', 'Title', "Start Date", 'End Date', "Reap", "User Type", "Status"];

//   const tableHeadData = ['S.No', 'Title', 'Referral Level', "Start Date", "Individual Reap", "Financial consultant Reap", "Status"];

//   const [rowTableData, setRowTableData] = useState([
//     {
//       tier_name: '--',
//       tier_level: "--",
//       createdAt: "--",
//       customer_discount: "--",
//       consultant_discount: "--",
//       is_active: "--"
//     },
//   ]);

//   useEffect(() => {
//     const tempArr = [];
//     getAllTiers?.data?.map((data, index) => {
//       return tempArr.push({
//         tier_name: data?.tier_name,
//         tier_level: data?.tier_level,
//         createdAt: format(new Date(data?.createdAt), 'MMMM d, yyyy'),
//         customer_discount: data?.customer_discount,
//         consultant_discount: data?.consultant_discount,
//         is_active: data?.is_active === true ? "Active" : "INactive",
//       });
//     });
//     setRowTableData(tempArr);
//   }, [
//     dispatch, getAllTiers,inactivateLastTier,activateLastTier
//   ]);



//   useEffect(() => {
//     dispatch(setHeaderName("User Registration"))
//     dispatch(setSubHeaderName("Gold Stake Schemes"));
//   }, [])
//   return (
//     <Grid container spacing={2}>

//       <Grid item xs={12} sx={{ width: "100px" }}>

//         <CustomTable tableEdit="tableEdit"
//           tableDelete="tableDelete"
//           tierStatusBtnShow={true}

//           tableData={rowTableData} title="Schemes" tableHeadData={tableHeadData}
//           modalName={UserReferralSchemeModal}
//         />
//       </Grid>
//     </Grid>
//   )
// }

// export default UserReferalsSheme



import React, { useEffect, useState } from 'react'
import CustomTable from '../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
import actions from "../../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import BannerinputGetModal from '../../ContentManagement/CommonModal/BannerModal/BannerinputGetModal';
import SchemeCreateModal from '../Modal/SchemeCreateModal';
import UserReferralSchemeModal from '../Modal/UserReferralSchemeModal';
import { format } from 'date-fns';
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModal';

const UserReferalsSheme = () => {
  const dispatch = useDispatch()
  const tableData = [
    { title: 'Diamond Referral', startDate: "15/Mar/2025", EndDate: "15/Mar/2026", Reap: "3.8g", userType: "individual", Status: "Pending" },
    { title: 'Ruby Referral', startDate: "15/Mar/2025", EndDate: "15/Mar/2026", Reap: "3.8g", userType: "individual", Status: "Pending" },

  ];



  const { getAllTiers } = useSelector(
    (state) => state?.getAllTiers
  );


  const { createTier } = useSelector(
    (state) => state?.createTier
  );


  const { inactivateLastTier } = useSelector(
    (state) => state?.inactivateLastTier
  );

  const { activateLastTier } = useSelector(
    (state) => state?.activateLastTier
  );


  const { updateTier } = useSelector(
    (state) => state?.updateTier
  );



  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllTiers`,
      };
      await dispatch(actions.GETALLTIERS(data1));
    };
    fetchData();
  }, [dispatch, createTier, inactivateLastTier, activateLastTier, updateTier]);

  // const tableHeadData = ['S.No', 'Title', "Start Date", 'End Date', "Reap", "User Type", "Status"];

  const tableHeadData = ['S.No', 'Title', 'Tier Level', 'Referral Level', "Start Date", "Individual Reap", "Financial consultant Reap", "Status"];

  const [rowTableData, setRowTableData] = useState([
    {
      tier_name: '--',
      tier_id: '--',
      tier_level: "--",
      createdAt: "--",
      customer_discount: "--",
      consultant_discount: "--",
      is_active: "--"
    },
  ]);

  useEffect(() => {
    const tempArr = [];
    getAllTiers?.data?.map((data, index) => {
      return tempArr.push({
        tier_name: data?.tier_name,
        tier_id: data?.tier_id,
        tier_level: data?.tier_level,
        createdAt: format(new Date(data?.createdAt), 'MMMM d, yyyy'),
        customer_discount: `${data?.customer_discount} g`,
        consultant_discount: `${data?.consultant_discount} g`,
        is_active: data?.is_active === true ? "Active" : "Inactive",
      });
    });
    setRowTableData(tempArr);
  }, [
    dispatch, getAllTiers, createTier, inactivateLastTier, activateLastTier, updateTier
  ]);

  const permissions = JSON.parse(localStorage.getItem("permissions"));


  useEffect(() => {
    // dispatch(setHeaderName("User Registration"))
    dispatch(setHeaderName("Master"));

    dispatch(setSubHeaderName(" Referrals Scheme"));
  }, [])
  return (
    <Grid container spacing={2}>

      <Grid item xs={12} sx={{ width: "100px" }}>

        <CustomTable
          // tableEdit="tableEdit"
          // tableDelete="tableDelete"
          tierStatusBtnShow={permissions?.SchemeManagement?.["Gold Stake Schemes"]?.edit}
          tableData={rowTableData} title="Schemes" tableHeadData={tableHeadData}
          modalName={UserReferralSchemeModal}
          editModalName={UserReferralSchemeModal}

          tableEdit={permissions?.SchemeManagement?.["Gold Stake Schemes"]?.edit}
          dataCreate={permissions?.SchemeManagement?.["Referral Schemes"]?.add}
        />
      </Grid>
    </Grid>
  )
}

export default UserReferalsSheme
